
import { getFaultList } from '@/api/other';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';

@Component({
  name: 'faultDialog'
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  faultVisible!: Boolean;

   @Prop({
     type: String,
     default: '1'
   })
  faultType!: String;

  private listQuery = {
    page: 1,
    size: 10,
    name: ''
  };
  private loading = false;
  private moreLoading = false;
  private faultData = [];
  private faultSelect = [];
  private selected = '';
  private selectedName = '';
  private moreShow = false;
  private pid = 0;
  resetData() {
    this.faultData = [];
    this.listQuery.name = '';
    this.selected = '';
  }

  created() {
    this.getFaultList();
  }

  getFaultList() {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      pid: this.pid,
      page: this.listQuery.page,
      is_need_child: 1,
      name: this.listQuery.name,
      type: this.faultType
    };
    getFaultList(params)
      .then(res => {
        // if (res.data === null || (res.data && res.data.page_count <= this.listQuery.page)) {
        //   this.moreShow = false;
        // } else {
        //   this.moreShow = true;
        // }
        if (res.data && res.data.list) {
          this.faultData = this.faultData.concat(...res.data.list);
          res.data.page_count <= this.listQuery.page ? this.moreShow = false : this.moreShow = true;
        } else {
          this.faultData = [];
          this.moreShow = false;
        }
        this.loading = false;
        this.moreLoading = false;
      })
      .catch(err => {
        this.loading = false;
        this.moreLoading = false;
        this.showErrorMsg(err.msg);
      });
  }
  close() {
    this.$emit('close', false);
  }
  loadMore() {
    this.moreLoading = true;
    this.listQuery.page += 1;
    this.getFaultList();
  }
  faultLayerMethods() {
    this.faultVisible = true;
    this.listQuery.page = 1;
    this.selected = '';
    this.getFaultList();
  }
  searchTable() {
    this.faultData = [];
    this.listQuery.page = 1;
    this.selected = '';
    this.getFaultList();
  }
  emptySearchTable() {
    this.resetData();
    this.searchTable();
  }
  confirmFault() {
    if (this.selected === '') {
      this.$notify({
        title: '提示',
        message: '请选择故障类型',
        duration: 3000,
        offset: 100,
        type: 'error'
      });
      return false;
    }
    this.$emit('selectresult', {
      id: this.selected,
      name: this.selectedName,
      type: this.faultType
    });
    this.close();
  }
  clickRadio(row:any) {
    this.selected = row.id;
    this.selectedName = row.name;
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
